export const nameIsRequired = value => (value ? undefined : 'Name is required')
export const clientReferenceIsRequired = value => (value ? undefined : 'ID number is required')


// WEBPACK FOOTER //
// ./src/smart-components/holder-form/validate.js